var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterLines = function SvgFilterLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#60646C",
    fillRule: "evenodd",
    d: "M1.333 4c0-.368.299-.667.667-.667h12a.667.667 0 1 1 0 1.334H2A.667.667 0 0 1 1.333 4m2 4c0-.368.299-.667.667-.667h8a.667.667 0 1 1 0 1.334H4A.667.667 0 0 1 3.333 8m2 4c0-.368.299-.667.667-.667h4a.667.667 0 0 1 0 1.334H6A.667.667 0 0 1 5.333 12",
    clipRule: "evenodd"
  })));
};
export default SvgFilterLines;